import { useParams } from 'react-router';
import { useAccount } from 'wagmi';

import { useAppSelector } from 'src/store/utils';

export function useProjectDashboardContext() {
  const { id: projectId } = useParams();
  const { address } = useAccount();
  const { networkInfo } = useAppSelector(state => state.app);

  return {
    projectId: projectId || '',
    address: address || undefined,
    network: networkInfo?.id || undefined,
  };
}
